import { render, staticRenderFns } from "./wuliu.vue?vue&type=template&id=4a111788&scoped=true&"
import script from "./wuliu.vue?vue&type=script&lang=js&"
export * from "./wuliu.vue?vue&type=script&lang=js&"
import style0 from "./wuliu.vue?vue&type=style&index=0&id=4a111788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a111788",
  null
  
)

export default component.exports